/*
 * Copyright (c) 2022 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import {RoleRightDefinitionVo} from "./role-right-definition-vo.model";
import {JSONable} from "@irian-ro/abstract-resource";

export class RoleWithRightsVo extends JSONable{
  uuid: string | undefined = undefined;
  name: string | undefined = undefined;
  description: string | undefined = undefined;
  owner: string | undefined = undefined;
  platformRole: boolean | undefined = undefined;
  selected: boolean | undefined = undefined;
  rightDefinitions: RoleRightDefinitionVo[] | undefined = undefined;
  companyType?:string;
}
